//#region src/variants/variants_icon.js
var variants_icon_default = {
	defaults: { props: { size: { tokenCategory: "icon-size" } } },
	default: { props: {
		name: { initialValue: "settings" },
		size: { initialValue: "500" }
	} }
};
//#endregion
export { variants_icon_default as default };

//# sourceMappingURL=variants_icon.js.map